<template>
  <label v-if="label">{{ label }}</label>
  <v-menu
    v-model="showTimepicker"
    :close-on-content-click="false"
    max-width="30vw"
    offset="-20"
  >
    <template #activator="{ props }">
      <v-text-field
        id="time-input"
        v-bind="props"
        variant="outlined"
        :placeholder="placeholder"
        :disabled="disabled"
        :value="formattedTime"
        :rules="rules"
        :error-messages="errors"
        data-cy="measurement-timepicker"
        @click="showTimepicker = true"
      />
    </template>
    <v-card class="pa-3 d-flex justify-center flex-column">
      <v-time-picker
        title=""
        :model-value="model"
        :min="min"
        :max="max"
        :allowed-hours="allowedHours"
        :allowed-minutes="allowedMinutes"
        @update:model-value="($event) => (model = $event)"
      />
      <v-btn
        class="align-self-end"
        color="primary"
        data-cy="time-input-accept"
        @click="showTimepicker = false"
      >
        {{ $t("buttons.accept") }}
      </v-btn>
    </v-card>
  </v-menu>
</template>

<script setup lang="ts">
  import { ref, computed } from "vue";
  import { format as dateFormat } from "date-fns-tz";

  interface Props {
    allowedHours?: Array<string> | object | ((val: number) => boolean);
    allowedMinutes?: Array<string> | object | ((val: number) => boolean);
    disabled?: boolean;
    errors?: Array<string>;
    format?: string;
    label?: string;
    max?: string;
    min?: string;
    placeholder?: string;
    rules?: Array<(val: number) => boolean>;
  }

  withDefaults(defineProps<Props>(), {
    disabled: false,
    label: "",
    format: null,
    rules: () => [],
    errors: () => [],
    min: null,
    max: null,
    placeholder: "hh:mm AM/PM",
    allowedHours: null,
    allowedMinutes: null,
  });

  const model = defineModel<string>();
  const showTimepicker = ref(false);

  const formattedTime = computed(() => {
    if (!model.value) {
      return "";
    }

    const [hours, minutes] = model.value.split(":").map((val) => parseInt(val));
    return dateFormat(new Date().setHours(hours, minutes, 0), "hh:mm aa zzz");
  });
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
